//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

const Center = ({ children }) => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      style={{ minHeight: 'calc(100vh - 160px)', textAlign: 'center' }}
    >
      <Grid item xs={6}>
        {children}
      </Grid>
    </Grid>
  );
};

const Loader = ({ children }) => {
  return (
    <Center>
      <Grid container direction="column" alignItems="center">
        <Grid item>
          <CircularProgress color="primary" />
        </Grid>
        <Grid item>
          <Typography variant="inherit">{children}</Typography>
        </Grid>
      </Grid>
    </Center>
  );
};

Loader.defaultProps = {
  children: null,
};

export default Loader;
